import { render, staticRenderFns } from "./BeaconNotificationList.vue?vue&type=template&id=383c1be7&"
import script from "./BeaconNotificationList.vue?vue&type=script&lang=js&"
export * from "./BeaconNotificationList.vue?vue&type=script&lang=js&"
import style0 from "./BeaconNotificationList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports